<div class="context-menu">
  <ul>
    <div *ngFor="let item of menuItems">
      <li class="item" (click)="applyAction(item)" *ngIf="item.isShow">
        <div class="left-wrapper">
          <div class="icon">
            <i class="fa {{item.icon}}" *ngIf="item.icon"></i>
          </div>
          <div class="text">{{item.text}}</div>
        </div>
      </li>
    </div>
  </ul>
</div>
